const Backbone = require('backbone');
const PricedOptionsCollection = require('collections/product/pricedoptions');
var OptionGroupModel = Backbone.Model.extend({
	defaults: {
		configured: false
	},

	initialize: function() {
		this.options = new PricedOptionsCollection(this.get('options'));
		this.options.on('options:changed', this._optionsChanged, this);
	},

	/**
	 * getSelected - Find the priced options that are selected
	 * @return {Array} Priced Option models that are selected
	 */
	getSelected: function() {
		return this.options.where({
			selected: true
		});
	},

	/**
	 * isConfigured - Shortcut to determine if this group of priced options is considered configured
	 * @return {Boolean} If the Option Group is configured
	 */
	isConfigured: function() {
		return this.get('configured');
	},

	/**
	 * _optionsChanged Event callback when child models (priced options) change
	 * @private
	 */
	_optionsChanged: function(payload) {
		var selected;

		if (this.get('required')) {
			selected = payload.where({
				selected: true
			});
			if (selected.length > 0) {
				this.set('configured', true);
			} else {
				this.set('configured', false);
			}
		}
		this.trigger('optionGroup:changed', this);
		Backbone.trigger('optionGroup:changed', this);
	}
});

module.exports = OptionGroupModel;
